import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { ErrorIllustration } from 'shared/assets/illustrations';
import { PageMeta } from 'shared/components/PageMeta';

export function ForbiddenPage() {
  const { t } = useI18n();
  return (
    <div className="state-page error-state">
      <PageMeta titleKey="errors.forbidden" />
      <ErrorIllustration />
      <p className="code-display">403</p>
      <h1>{t('forbidden.title')}</h1>
      <p>{t('forbidden.body')}</p>
      <Link className="btn btn-primary" to={paths.welcome}>{t('notFound.home')}</Link>
    </div>
  );
}
